<template>
  <div class="t-overflow-x-auto">
    <div
      class="t-align-middle t-inline-block t-min-w-full freight-table t-overflow-y-auto t-mt-2"
      role="table"
    >
      <div class="t-flex t-justify-between t-border-t-2 t-border-b-2 t-border-gray-500 t-mb-2 t-pt-4 t-pb-2 t-font-semibold">
        <p class="t-w-14 t-flex">
          Quantity
        </p>
        <p class="t-w-36 t-px-3 content-center">
          Package Type
        </p>
        <p class="t-flex t-w-44 t-px-3">
          Type of Goods
        </p>
        <p class="t-flex t-w-44">
          Description
        </p>
        <p class="t-flex t-w-32 t-px-3">Weight (kg)</p>
        <p class="t-flex t-w-28 t-px-2">Volume (&#13221;)</p>
      </div>
      <div
        v-for="freightLine in freightLines"
        class="t-flex t-justify-between t-mb-2"
      >
        <p class="t-w-14 t-flex">
          {{ freightLine.quantity }}
        </p>
        <p class="t-w-36 t-px-3 content-center">
          {{ freightLine.packageType }}
        </p>
        <p class="t-flex t-w-44 t-px-3">
          {{ freightLine.typeOfGoods }}
        </p>
        <p class="t-flex t-w-44">
          {{ freightLine.description }}
        </p>
        <p class="t-flex t-w-32 t-px-3">
          {{ freightLine.weight }} kgs
        </p>
        <p class="t-flex t-w-28 t-px-2">
          {{ freightLine.volume }} (&#13221;)
        </p>
      </div>

      <div class="t-flex t-justify-between t-mt-10 t-mb-2 t-border-t-2 t-border-b-2 t-border-gray-500 t-py-2">
        <p class="t-w-14 t-flex">
          TOTAL
        </p>
        <p class="t-w-36 t-px-3 content-center">

        </p>
        <p class="t-flex t-w-44 t-px-3">

        </p>
        <p class="t-flex t-w-44">

        </p>
        <p class="t-flex t-w-32 t-px-3">
          {{ getTotalWeight(freightLines) }} kgs
        </p>
        <p class="t-flex t-w-28 t-px-2">
          {{ getTotalVolume(freightLines) }} (&#13221;)
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FreightTable',
  props: {
    freightLines: {
      type: Array,
      required: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    getTotalWeight(freightLines) {
      let totalWeight = 0.0;
      for (let freightLine of freightLines) {
        totalWeight += parseFloat(freightLine.weight);
      }
      return totalWeight.toFixed(2);
    },
    getTotalVolume(freightLines) {
      let totalVolume = 0.0;
      for (let freightLine of freightLines) {
        totalVolume += parseFloat(freightLine.volume);
      }
      return totalVolume.toFixed(2);
    },
  }
}
</script>

<style scoped>

</style>